import React, { useEffect, useState } from 'react';
import { Modal, Form, Select } from '@maxtropy/components';
import { apiV2DistributionCabinetRoomListPost } from '@maxtropy/device-customer-apis-v2';
interface Option {
  label: string | undefined;
  value: number | undefined;
}

interface Props {
  open: boolean;
  setOpen: (v: boolean) => void;
  standRoomData?: number[];
  onSave: (updatedData: number[]) => void;
}
const Standmodal: React.FC<Props> = ({ open, setOpen, standRoomData, onSave }) => {
  const [form] = Form.useForm();
  const [standRoomOp, setStandRoomOp] = useState<Option[] | undefined>([]);
  useEffect(() => {
    form.setFieldsValue({ roomList: standRoomData });
    apiV2DistributionCabinetRoomListPost({}).then(res => {
      const dataRes = res.list ?? [];
      const options = dataRes.map(i => ({
        label: i.name,
        value: i.id,
      }));
      setStandRoomOp(options);
    });
  }, []);

  const handleOk = async () => {
    const res = form.getFieldValue('roomList');
    onSave(res);
    setOpen(false);
  };
  return (
    <Modal title="编辑供电站房" size="small" open={open} onOk={handleOk} okText="确认" onCancel={() => setOpen(false)}>
      <div>
        <Form form={form} className="table-form" isOrigin initialValues={{ roomList: [] }}>
          <Form.Item
            label="站房选择"
            name="roomList"
            style={{ marginBottom: '0px' }}
            rules={[
              () => ({
                validator(_, value) {
                  if (value && value.length > 10) {
                    return Promise.reject(new Error('最多只能选择10个站房'));
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Select
              style={{ width: '100%' }}
              placeholder="请选择"
              options={standRoomOp}
              showSearch
              optionFilterProp="label"
              mode="multiple"
              maxCount={10}
            />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default Standmodal;
